import { createContext } from 'react';

import type { FreemiumAction, IFreemiumState } from './interfaces';

interface FreemiumContext {
  freemiumState: IFreemiumState;
  reducerDispatch: React.Dispatch<FreemiumAction>;
}

export const FreemiumContext = createContext<FreemiumContext>({
  freemiumState: {
    featuresOfPremiumRef: null,
    isListingActive: false,
    filters: {
      beds: undefined,
      propertyType: undefined,
      filterType: 'cityState',
    },
    canAccessTopOfFunnelPremium: false,
  },
  reducerDispatch: () => null,
});
